import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { FilterNationalOffices } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { meta, tableCommon } from 'helpers/decorators'
import { apiOrganizations } from 'helpers/decorators/api'
import { nationalOffices as nationalOfficesLayout } from 'constants/layout'
import { Export } from 'containers/misc'
import config from 'config'

@meta({
  title: 'National Offices',
  intlKey: 'pageTitle.national_offices'
})
@apiOrganizations({
  list: true,
  filter: 'NAOs',
  useCommonLimit: true
})
@tableCommon()
class NationalOffices extends Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired,
    exportOrganizations: PropTypes.func.isRequired,
    setOrganizationsParams: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func
  }

  render() {
    const {
      organizations: { loading, listNAOs, offset, limit, pages, sort },
      setOrganizationsParams,
      setCommonLimit
    } = this.props
    const exportComponent = (
      <Export
        exportName="National offices"
        toExport={this.props.exportOrganizations}
        exportSchemeValue="naos"
        count={this.props.organizations && this.props.organizations.count}
      />
    )

    return (
      <div>
        <FilterNationalOffices />
        <Table
          loading={loading}
          length={listNAOs.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={nationalOfficesLayout.tableHeaders}
          setParams={setOrganizationsParams}
          exportComponent={exportComponent}
        >
          <Data>
            {listNAOs.map(({ id, globalId, name, country }) => (
              <tr key={id}>
                <td>
                  <Link to={`${config.publicPath}/national-offices/${id}/detail`}>{globalId}</Link>
                </td>
                <td>{name}</td>
                <td>{get(country, 'name')}</td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}

export default NationalOffices
